import { Text, View } from '@react-pdf/renderer';

import { fontStyles } from '../styles.ts';
import { FlexRow } from './FlexRow.tsx';

type ListType = 'bullet' | 'number';

type ListProps = {
  type: ListType;
  items: JSX.Element[];
};

export const List = ({ type, items }: ListProps) => (
  <View style={{ marginTop: -4 }}>
    {items.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <FlexRow key={index} alignItems="flex-start">
        <Text style={fontStyles.listItem}>{type === 'bullet' ? '•' : `${index + 1}.`}</Text>
        {item}
      </FlexRow>
    ))}
  </View>
);
